import { memo } from "react";
import { Button } from "@/components/ui/button";

const Footer = memo(() => {
  return (
    <footer className="bg-accent dark:bg-card shadow">
      <div className="container px-3 mx-auto rounded-lg sm:flex sm:items-center sm:justify-between p-4 sm:p-6 xl:p-8 antialiased">
        <p className="mb-4 text-sm text-center text-accent-foreground sm:mb-0">
          <span className="me-1">&copy; {new Date().getFullYear()}</span>
          <a
            href="https://agetechcollaborative.org/"
            className="hover:underline"
            target="_blank"
          >
            AgeTech Collaborative
          </a>
          . All rights reserved.
        </p>
        <div className="flex justify-center items-center space-x-1">
          <Button className="text-accent-foreground" variant="link" asChild>
            <a href="https://agetechcollaborative.org/greenhouse/">
              Venture Studio / Greenhouse
            </a>
          </Button>
        </div>
      </div>
    </footer>
  );
});

export { Footer };
